import { render, staticRenderFns } from "./tab-inquiry.vue?vue&type=template&id=546d9882&scoped=true&"
import script from "./tab-inquiry.vue?vue&type=script&lang=js&"
export * from "./tab-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./tab-inquiry.vue?vue&type=style&index=0&id=546d9882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d9882",
  null
  
)

export default component.exports